// extracted by mini-css-extract-plugin
export default {"changeAppCredentials":"x5wOpGACC1"};